import { create } from 'zustand';
import { iMostraSeuAprovaContent, MostraSeuAprovaKey } from './data';

/**
 * Modal aberto da campanha #mostraseuaprova.
 *
 * Vive fora da árvore React porque os gatilhos partem de páginas espalhadas
 * (fim de aula, correção de redação, simulado…) enquanto o modal fica montado
 * uma única vez no topo da aplicação — mesmo arranjo do upsell do freemium.
 */
interface iMostraSeuAprovaStore {
  /** Conteúdo em exibição, ou `null` quando nada está aberto. */
  content: MostraSeuAprovaKey | iMostraSeuAprovaContent | null;
  open: (content: MostraSeuAprovaKey | iMostraSeuAprovaContent) => void;
  close: () => void;
}

export const useMostraSeuAprovaStore = create<iMostraSeuAprovaStore>((set) => ({
  content: null,
  open: (content) => set({ content }),
  close: () => set({ content: null }),
}));

/** Atalho para abrir fora de contexto React. */
export const openMostraSeuAprova = (
  content: MostraSeuAprovaKey | iMostraSeuAprovaContent
) => useMostraSeuAprovaStore.getState().open(content);
